import { generateTestId } from "@client-shared";

export const setAppFooterTestId = (identifier: string): string =>
  generateTestId("AppFooter", identifier);
